import React, { useState } from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { PageHeaderProvider } from '../../context/PageHeaderContext';

interface LayoutProps {
  children: React.ReactNode;
  themeId: string;
  onThemeChange: (id: string) => void;
}

const Layout: React.FC<LayoutProps> = ({ children, themeId, onThemeChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <PageHeaderProvider>
    <Box sx={{ display: 'flex', height: 'var(--app-h)', overflow: 'hidden' }}>
      {!isMobile && (
        <Sidebar themeId={themeId} onThemeChange={onThemeChange} />
      )}
      {isMobile && (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          sx={{ '& .MuiDrawer-paper': { width: 248, overflow: 'hidden', background: 'var(--sidebar-bg)', backdropFilter: 'blur(24px)' } }}
        >
          <Sidebar onClose={() => setDrawerOpen(false)} themeId={themeId} onThemeChange={onThemeChange} />
        </Drawer>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflow: 'hidden' }}>
        <Topbar onMenuClick={isMobile ? () => setDrawerOpen(true) : undefined} themeId={themeId} onThemeChange={onThemeChange} />
        <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
          {children}
        </Box>
      </Box>
    </Box>
    </PageHeaderProvider>
  );
};

export default Layout;
